import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '雨声助眠', path: '/category?tab=rain-sound' },
    { label: '耳语助眠', path: '/category?tab=whisper' },
    { label: '敲击音助眠', path: '/category?tab=tapping' },
    { label: '白噪音助眠', path: '/category?tab=white-noise' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="no-underline">
              <span className="text-xl font-heading font-semibold text-foreground-950">
                眠境
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              专业的助眠 ASMR 内容精选平台，用声音的力量帮助每个人获得更好的睡眠。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-nav" className="text-foreground-950 no-underline">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 no-underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="text-foreground-950 no-underline">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 no-underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-contact" className="text-foreground-950 no-underline">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-600">
                <i className="ri-mail-line mr-2"></i>
                hello@mianjing-sleep.com
              </li>
              <li className="text-sm text-foreground-600">
                <i className="ri-wechat-line mr-2"></i>
                微信公众号：眠境ASMR
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 眠境 MianJing. 助眠 ASMR 内容精选平台。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-600 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="https://bilibili.com" target="_blank" rel="nofollow noopener" className="text-foreground-500 hover:text-primary-600 transition-colors duration-200" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}